export class WebupImage {
  id: number
  sort_no: number
  group_no: number
  page_no: string
  file_name: string
  student_no_character: string
  student_name: string
  dpi: number
  width: number
  height: number
  angle: number = 0
  errors: string[] = []
  disp_file_name: string
  hosei_positions: any = []
  correct_hosei_positions: number[][] = []

  constructor(item: any){
    this.id = item.id;
    this.sort_no = item.sort_no;
    this.group_no = item.group_no;
    this.page_no = item.page_no;
    this.file_name = item.file_name;
    this.student_no_character = item.student_no_character;
    this.student_name = item.student_name;
    this.dpi = item.dpi;
    this.width = item.width;
    this.height = item.height;
    this.errors = item.errors;
    const splitFilePath = item.file_name.split("/");
    this.disp_file_name = splitFilePath[splitFilePath.length - 1];

    if(item.hosei_positions != null){
      this.hosei_positions = item.hosei_positions;
    }

    if(item.correct_hosei_positions){
      this.correct_hosei_positions = item.correct_hosei_positions;
    }
  }
}

export class Sheet {
  id: number
  correct_image_size: number[]
  is_use_hosei: boolean

  constructor(x: any){
    this.id = x.id;
    this.correct_image_size = x.correct_image_size;
    this.is_use_hosei = x.is_use_hosei;
  }
}

export class ImageItem {
  fileName: string
  base64Image: string

  constructor(fileName: string, base64Image: string){
    this.fileName = fileName;
    this.base64Image = base64Image;
  }
}

export class SearchCondition {
  student_no_character: string = ""
  student_name: string = ""
  room_name: string = ""
  page: number = 1
  row_count: number =  10
}

export class Examinee {
  student_no_character: number
  student_name: string
  room_name: string
  full_count: number

  constructor(x: any){
    this.student_no_character = x.student_no_character;
    this.student_name = x.student_name;
    this.room_name = x.room_name
    this.full_count = x.full_count;
  }
}

export const DirectionEnum = Object.freeze({Left: 1, Right: 2});

export const rotateHoseiPosition = (hosei_positions: any[], direction: number, angle: number, imageW: number, imageH: number) => {

  const newHoseiPositions: number[][] = [[-1, -1], [-1, -1], [-1, -1], [-1, -1]];

  const width = angle == 90 || angle == 270 ? imageW : imageH;
  const height = angle == 90 || angle == 270 ? imageH : imageW;

  hosei_positions.forEach((hosei_position: any, i) => {
    if(direction == DirectionEnum.Left){
      if(i == 0){
        newHoseiPositions[1][0] = hosei_position.rim[1];
        newHoseiPositions[1][1] = width - hosei_position.rim[0];
      }else if(i == 1){
        newHoseiPositions[2][0] = hosei_position.rim[1];
        newHoseiPositions[2][1] = width - hosei_position.rim[0];
      }else if(i == 2){
        newHoseiPositions[3][0] = height - (height - hosei_position.rim[1]);
        newHoseiPositions[3][1] = width - hosei_position.rim[0];
      }else if(i == 3){
        newHoseiPositions[0][0] = hosei_position.rim[1];
        newHoseiPositions[0][1] = width - hosei_position.rim[0];
      }
    }else{
      if(i == 0){
        newHoseiPositions[3][0] = height - hosei_position.rim[1];
        newHoseiPositions[3][1] = hosei_position.rim[0];
      }else if(i == 1){
        newHoseiPositions[0][0] = height - hosei_position.rim[1];
        newHoseiPositions[0][1] = hosei_position.rim[0];
      }else if(i == 2){
        newHoseiPositions[1][0] = height - hosei_position.rim[1];
        newHoseiPositions[1][1] = hosei_position.rim[0];
      }else if(i == 3){
        newHoseiPositions[2][0] = height - hosei_position.rim[1];
        newHoseiPositions[2][1] = hosei_position.rim[0];
      }
    }
  });

  hosei_positions.forEach((hosei_position: any, i) => {
    hosei_position.rim[0] = newHoseiPositions[i][0];
    hosei_position.rim[1] = newHoseiPositions[i][1];
  })

  return hosei_positions;
}